export default __webpack_public_path__ + "static/media/Mark-2-3D-Model-01.03a3086b.jpg";